export default __webpack_public_path__ + "static/media/copyBlack.5c13c8af.svg";